/* eslint-disable */
import React, { useEffect, useState, useContext } from 'react';
import { flowRight, get } from 'lodash';
import { connect, useDispatch } from 'react-redux';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import { setList } from 'api/actions';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { ModalContext } from 'App';
import TransactionInformation from '../components/TransactionInformation';
import TaxpayerInformation from '../components/TaxpayerInformation';
import BusinessInformation from '../components/BusinessInformation';
import BusinessActivities from '../components/BusinessActivities';
import FinalFeesInformation from '../components/FinalFeesInformation';
import Requirements from '../components/Requirements';
import UpdateModal from '../modals/UpdateModal';
import Location from '../components/Location';
import AddRemarksModal from '../modals/AddRemarksModal';
import * as actions from '../actions';
import * as c from '../constant';
import { getInitials } from '../helper';
import useStartAssessment from '../hooks/useStartAssessment';
import useStartLicenseAssessment from '../hooks/useStartLicenseAssessment';
import useGenerateBIN from '../hooks/useGenerateBIN';
import useInitialComputation from '../hooks/useInitialComputation';
import InitialComputationModal from '../modals/InitialComputationModal';
import useApproveConfirmation from '../hooks/useApproveConfirmation';
import useRejectConfirmation from '../hooks/useRejectConfirmation';
import useReleaseConfirmation from '../hooks/useReleaseConfirmation';
import useGenerateSOAConfirmation from '../hooks/useGenerateSOAConfirmation';
import useApproveOwnershipConfirmation from '../hooks/useApproveOwnershipConfirmation';
import useForwardToLicense from '../hooks/useForwardToLicense';
import ViewSOA from '../components/ViewSOA';
import ViewRetirementCertificate from '../components/ViewRetirementCertificate';
import ViewOR from '../components/ViewOR';
import ViewPermit from '../components/ViewPermit';
import ViewGeneratedBin from '../components/ViewGeneratedBin';
import ViewLogs from '../components/ViewLogs';
import ChangeRequestModal from '../modals/ChangeRequest/ChangeRequestModal';
import RetirementModal from '../modals/Retirement/RetirementModal';
import ViewUpdateCalculation from '../components/ViewUpdateCalculation';
import UpdateCalculationsRetirementMultiple from '../components/UpdateCalculationsRetirementMultiple';
import useCancelSoa from '../hooks/useCancelSoa';
import ViewApplication from '../components/ViewApplication';
import useCancelApplication from '../hooks/useCancelApplication';
import AssessRenewApplicationModal from '../modals/AssessRenewApplicationModal';
import useReturnToPermit from '../hooks/useReturnToPermit';
import RecalCalculateSOADate from '../modals/RecalCalculateSOADate';
import SideScrollingTab from 'modules/common/components/SideScrollingTab';
import PreviousOR from '../components/PreviousOR';
import UploadCTCModal from '../modals/UploadCTCModal';
import useRenewalStartAssessment from '../hooks/useRenewalStartAssessment';
import useRenewalApprove from '../hooks/useRenewalApprove';
import useRenewalReturnToAssessment from '../hooks/useRenewalReturnToAssessment';
import useRenewalStartLicenseAssessment from '../hooks/useRenewalStartLicenseAssessment';
import useQuarterlyStartAssessment from '../hooks/useQuarterlyStartAssessment';
import useReassessApplication from '../hooks/useReassessApplication';
import PaymentPostingModal from '../components/PaymentPostingModal';
import UpdateBilling from '../modals/UpdateBilling';
import UpdateBusinessState from '../modals/UpdateBusinessState';
import UpdateOrDate from '../modals/UpdateOrDate';
import ManualPaymentPostingModal from '../modals/ManualPaymentPostingModal';
import AddApprovalNotesModal from '../modals/AddApprovalNotesModal';

function Content({
  match,
  getItem,
  item,
  permitApplication,
  adminProfile,
  isLoading,
  toggleAssessment,
  toggleLicenseAssessment,
  assisting,
  generatingBIN,
  generateBIN,
  initialComputing,
  initialComputation,
  approving,
  approve,
  rejecting,
  // reject,
  releasing,
  release,
  ownershipApproving,
  approveOwnership,
  permissions,
  list,
  refreshList,
  generatingSOA,
  generateSOA,
  forwardingToLicense,
  forwardToLicense,
  cancellingSoa,
  cancelSoa,
  cancellingApplication,
  cancelApplication,
  returningToPermit,
  returnToPermit,
  recalculatingSOA,
  recalculateSOA,
  inquirePreviousOR,
  toggleReassessmentQuarterly,
  reassessingApplication,
  reassessApplication,
}) {
  const [activities, setActivities] = useState([]);
  const dispatch = useDispatch();
  const setModal = useContext(ModalContext);

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
    getItem(match.params.bpls_id);
  };

  const isStartAssessment = get(item, 'attributes.is_start_assessment');
  const isValidated = get(
    item,
    'included.bplsApplication.attributes.is_validated'
  );
  const isDelinquent =
    get(item, 'attributes.transaction_type') === 'DELINQUENT';
  const isRetirement =
    get(item, 'attributes.transaction_type') === 'RETIREMENT';

  const startAssessment = useStartAssessment(
    assisting,
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    get(item, 'included.bplsApplication.attributes.status'),
    () => {
      toggleAssessment(get(item, 'id'), {}, () => {
        getItem(get(item, 'id'));
      });
    }
  );

  const renewalStartAssessment = useRenewalStartAssessment(
    assisting,
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    get(item, 'included.bplsApplication.attributes.status'),
    () => {
      toggleAssessment(get(item, 'id'), {}, () => {
        getItem(get(item, 'id'));
      });
    }
  );

  const quarterlyStartAssessment = useQuarterlyStartAssessment(
    assisting,
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    () => {
      const action = !isStartAssessment ? 'start' : 'stop';
      toggleReassessmentQuarterly(get(item, 'id'), action, {}, () => {
        getItem(get(item, 'id'));
      });
    }
  );

  const startLicenseAssessment = useStartLicenseAssessment(
    assisting,
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    get(item, 'included.bplsApplication.attributes.status'),
    () => {
      toggleLicenseAssessment(get(item, 'id'), {}, () => {
        getItem(get(item, 'id'));
      });
    }
  );

  const renewalStartLicenseAssessment = useRenewalStartLicenseAssessment(
    assisting,
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    get(item, 'included.bplsApplication.attributes.status'),
    () => {
      toggleLicenseAssessment(get(item, 'id'), {}, () => {
        getItem(get(item, 'id'));
      });
    }
  );

  const initialComputationHooks = useInitialComputation(
    initialComputing,
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    get(item, 'included.bplsApplication.attributes.status'),
    get(item, 'attributes.soa_generated_at'),
    () => {
      initialComputation(get(item, 'id'), {}, (res) => {
        getItem(get(item, 'id'));
        dispatch(setList(`${c.INITIAL_COMPUTATION}`, get(res, 'res.data')));
        setModal({
          isOpen: true,
          content: <InitialComputationModal permitId={+match.params.bpls_id} />,
          title: 'Initial Computation',
          modalSize: 'modal-lg',
        });
      });
    }
  );

  const generateBINHooks = useGenerateBIN(
    generatingBIN,
    get(item, 'included.bplsBusiness.attributes.bin'),
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    isValidated,
    () => {
      generateBIN(get(item, 'id'), {}, (response) => {
        getItem(get(item, 'id'));
        setModal({
          isOpen: true,
          content: <ViewGeneratedBin data={response} />,
          title: 'Generated BIN',
          modalSize: 'modal-md',
        });
      });
    }
  );

  const approveOwnershipComputation = useApproveOwnershipConfirmation(
    ownershipApproving,
    get(item, 'included.bplsBusiness.attributes.bin'),
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    get(item, 'included.bplsBusiness.attributes.taxpayer_id'),
    () => {
      approveOwnership(get(item, 'id'), {}, () => {
        getItem(get(item, 'id'));
      });
    }
  );

  const approveConfirmation = useApproveConfirmation(
    approving,
    get(item, 'included.bplsBusiness.attributes.bin'),
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    () => {
      approve(get(item, 'id'), {}, () => {
        getItem(get(item, 'id'));
      });
    }
  );

  const rejectConfirmation = useRejectConfirmation(
    rejecting,
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    get(item, 'included.bplsApplication.attributes.status'),
    isDelinquent,
    isRetirement,
    get(item, 'id')
  );

  const releaseConfirmation = useReleaseConfirmation(
    releasing,
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    (remarks) => {
      release(get(item, 'id'), { remarks }, () => {
        getItem(get(item, 'id'));
      });
    }
  );

  const generateSOAConfirmation = useGenerateSOAConfirmation(
    generatingSOA,
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    get(item, 'included.bplsApplication.attributes.status'),
    get(item, 'attributes.soa_generated_at'),
    _.get(item, 'attributes.transaction_type') !== 'DELINQUENT' &&
      _.get(item, 'attributes.transaction_type') !== 'RETIREMENT'
      ? () => {
          generateSOA(get(item, 'id'), {}, (response) => {
            getItem(get(item, 'id'));
            setModal({
              isOpen: true,
              content: <ViewSOA data={item} generateAmount={response} />,
              title: 'View e-SOA',
              modalSize: 'modal-xl',
            });
          });
        }
      : () => {
          _.get(item, 'attributes.transaction_type') === 'DELINQUENT'
            ? setModal({
                isOpen: true,
                content: <ViewUpdateCalculation data={item} />,
                title: 'Update Delinquent Calculation',
                modalSize: 'modal-xl',
              })
            : setModal({
                isOpen: true,
                content: <UpdateCalculationsRetirementMultiple data={item} />,
                title: 'Update Retirement Calculation',
                modalSize: 'modal-xl',
              });
        }
  );

  const forwardToLicenseConfirmation = useForwardToLicense(
    forwardingToLicense,
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    get(item, 'included.bplsApplication.attributes.status'),
    () => {
      forwardToLicense(get(item, 'id'), {}, () => {
        getItem(get(item, 'id'));
      });
    }
  );

  const renewalApproveConfirmation = useRenewalApprove(
    forwardingToLicense,
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    get(item, 'included.bplsApplication.attributes.status'),
    () => {
      forwardToLicense(get(item, 'id'), {}, () => {
        toggleLicenseAssessment(get(item, 'id'), {}, () => {
          getItem(get(item, 'id'));
        });
      });
    }
  );

  const cancelSoaConfirmation = useCancelSoa(
    cancellingSoa,
    get(item, 'attributes.soa_generated_at'),
    get(item, 'attributes.transaction_status'),
    get(item, 'included.bplsApplication.attributes.status'),
    (remarks) => {
      cancelSoa(get(item, 'id'), { remarks }, () => {
        getItem(get(item, 'id'));
      });
    }
  );

  const cancelApplicationConfirmation = useCancelApplication(
    cancellingApplication,
    get(item, 'included.bplsApplication.attributes.status'),
    get(item, 'attributes.created_at'),
    (remarks) => {
      cancelApplication(get(item, 'id'), { remarks }, () => {
        getItem(get(item, 'id'));
      });
    }
  );

  const returnToPermitConfirmation = useReturnToPermit(
    returningToPermit,
    isStartAssessment,
    get(item, 'included.bplsApplication.attributes.status'),
    (remarks) => {
      returnToPermit(get(item, 'id'), { remarks }, () => {
        getItem(get(item, 'id'));
      });
    }
  );

  const renewalReturnToAssessmentConfirmation = useRenewalReturnToAssessment(
    returningToPermit,
    isStartAssessment,
    get(item, 'included.bplsApplication.attributes.status'),
    (remarks) => {
      returnToPermit(get(item, 'id'), { remarks }, () => {
        getItem(get(item, 'id'));
      });
    }
  );
  const reassessApplicationConfirmation = useReassessApplication(
    reassessingApplication,
    get(item, 'attributes.transaction_status'),
    () => {
      const finalActivities = activities.map((item) => {
        return {
          id: item.id,
          gross_amount: item.attributes.gross_amount,
          override_amount: item.attributes.override_amount || 0,
        };
      });
      reassessApplication(
        get(item, 'id'),
        { activities: finalActivities },
        () => {
          getItem(get(item, 'id'));
        }
      );
    }
  );

  const handlePreviousOR = (e) => {
    e.preventDefault();

    inquirePreviousOR(get(item, 'id'), () => {
      setModal({
        isOpen: true,
        content: <PreviousOR data={item} />,
        title: `Previous OR`,
        modalSize: 'modal-xl',
      });
    });
  };

  const handleViewSOA = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <ViewSOA data={item} />,
      title: `View e-SOA`,
      modalSize: 'modal-xl',
    });
  };

  const handleViewRetirementCertificate = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <ViewRetirementCertificate data={item} />,
      title: `View Retirement Certificate`,
      modalSize: 'modal-xl',
    });
  };

  const handleViewOR = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <ViewOR data={item} />,
      title: `View e-OR`,
      modalSize: 'modal-xl',
    });
  };

  const handleViewPermit = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <ViewPermit data={item} />,
      title: `View e-Permit`,
      modalSize: 'modal-xl',
    });
  };

  const handleViewApplication = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <ViewApplication data={item} />,
      title: `View e-Application`,
      modalSize: 'modal-xl',
    });
  };

  const isPrintedApplication = _.get(
    _.get(permitApplication, 'included', []).filter(
      (item) => item.type === 'bpls_business_permit_applications'
    ),
    '0.attributes.is_printed',
    0
  );

  useEffect(() => {
    if (match.params.bpls_id && !_.isEmpty(list)) {
      getItem(match.params.bpls_id);
    }
  }, [match.params.bpls_id, list]);

  useEffect(() => {
    if (
      isStartAssessment &&
      (activities.length < 1 ||
        activities !== get(item, 'included.bplsBusinessActivities')) &&
      get(item, 'attributes.transaction_type') === 'QUARTERLY' &&
      ['REASSESSING'].indexOf(get(item, 'attributes.transaction_status')) > -1
    ) {
      setActivities(get(item, 'included.bplsBusinessActivities'));
    }
  }, [item, isStartAssessment]);

  const handleUpdateInformation = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateModal updateList={item} id={item.id} updating={isLoading} />
      ),
      title: `Unified Application Form`,
      modalSize: 'modal-xl',
    });
  };

  const handleAssessRenewApplication = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <AssessRenewApplicationModal
          updateList={item}
          id={item.id}
          updating={isLoading}
        />
      ),
      title: `Assess Renew Application`,
      modalSize: 'modal-xl',
    });
  };

  const handleChangeRequestModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <ChangeRequestModal
          updateList={item}
          id={item.id}
          updating={isLoading}
          closeModal={closeModal}
        />
      ),
      title: `Assess Application`,
      modalSize: 'modal-xl',
    });
  };

  const handleRetirementAssessModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <RetirementModal
          updateList={item}
          id={item.id}
          updating={isLoading}
          closeModal={closeModal}
        />
      ),
      title: `Assess Application`,
      modalSize: 'modal-xl',
    });
  };

  const handleAddRemarks = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <AddRemarksModal
          updateList={get(data, 'included.bplsApplication.attributes')}
          id={data.id}
        />
      ),
      title: `Add Business Remarks`,
      modalSize: 'modal-lg',
    });
  };

  const handleAddApprovalNotes = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <AddApprovalNotesModal
          updateList={get(data, 'included.bplsApplication.attributes')}
          id={data.id}
        />
      ),
      title: `Add Approval Notes`,
      modalSize: 'modal-lg',
    });
  };

  const handleViewLogs = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ViewLogs id={item.id} />,
      title: `View Logs`,
      modalSize: 'modal-xl',
    });
  };

  const handleRecalculateSOADate = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <RecalCalculateSOADate id={item.id} />,
      title: `Recalculate SOA`,
      modalSize: 'modal-md',
    });
  };

  const handleUploadCTC = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <UploadCTCModal
          id={item.id}
          updateList={_.get(item, 'included.bplsApplication.attributes')}
        />
      ),
      title: `Upload CTC`,
      modalSize: 'modal-md',
    });
  };

  // check payment posting
  const handlePaymentPosting = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <PaymentPostingModal
          // transactionInfo={transactionInfo}
          // id={selectedTransaction}
          // id={match.params.bpls_id}
          transactionInfo={item}
          id={item.id}
          getItem={getItem}
          item={item}
        />
      ),
      title: `Check Posting`,
      modalSize: 'modal-md',
    });
  };

  const handleUpdateBilling = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <UpdateBilling
          id={item.id}
          type={get(item, 'attributes.transaction_type')}
        />
      ),
      title: `Update Billing`,
      modalSize: 'modal-md',
    });
  };

  const handleUpdateBusinessState = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <UpdateBusinessState
          id={item.id}
          data={_.get(item, 'included.bplsBusiness.attributes')}
          refreshList={refreshList}
        />
      ),
      title: `Update Business State`,
      modalSize: 'modal-xl',
    });
  };

  const handleUpdateOrDate = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <UpdateOrDate id={item.id} data={item} />,
      title: `Update OR Date`,
      modalSize: 'modal-md',
    });
  };

  const handleManualPaymentPosting = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <ManualPaymentPostingModal id={item.id} data={item} />,
      title: `Manual Payment Posting`,
      modalSize: 'modal-md',
    });
  };

  const handlereassessApplication = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <ReassessApplicationModal id={item.id} activities={{}} />,
      title: `Reassess Application`,
      modalSize: 'modal-md',
    });
  };

  const checkAssessor = () => {
    if (_.get(item, 'attributes.is_start_assessment') > 0) {
      return (
        +_.get(adminProfile, 'profile_id') ===
        _.get(item, 'attributes.start_assess_by')
      );
    }
    if (_.get(item, 'attributes.is_start_assessment') === 0) return true;
  };

  return (
    <div className="card-section-content container-fluid">
      {isLoading && (
        <div className="loading">
          <div className="spinner text-center">
            <span className="fas fa-1x fa-spin fa-spinner" />
          </div>
        </div>
      )}
      <div className="p-3">
        <div className="d-flex mb-3">
          <div className="mr-2">
            <div className="d-flex round-image justify-content-center">
              {get(item, 'included.taxPayer.attributes.photo') && (
                <img
                  className="round-image"
                  src={get(item, 'included.taxPayer.attributes.photo')}
                  alt="Profile"
                />
              )}
              {!get(item, 'included.taxPayer.attributes.photo') && (
                <h3 className="d-flex align-items-center initials mb-0">
                  {getInitials(get(item, 'attributes.name'))}
                </h3>
              )}
            </div>
          </div>
          <div className="d-flex flex-column align-items-start flex-grow-1">
            <h1>
              {get(item, 'included.bplsApplication.attributes.business_name')}
            </h1>
            <h4 className="text-primary">{get(item, 'attributes.name')}</h4>
          </div>
        </div>
      </div>
      <div className="row justify-content-end mb-1 mr-1">
        {['FOR PERMIT PROCESS', 'FOR LICENSE ASSESSMENT'].indexOf(
          get(item, 'included.bplsApplication.attributes.status')
        ) > -1 &&
          Acl(permissions, ['E2E BPLS PREVIOUS E-OR']) &&
          checkAssessor() &&
          get(item, 'included.bplsApplication.attributes.type') === 'RENEWAL' &&
          isStartAssessment === 1 && (
            <div className="mx-2">
              <button
                className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
                type="button"
                onClick={handlePreviousOR}
              >
                Previous OR
              </button>
            </div>
          )}
        {['NEW', 'RENEWAL'].indexOf(
          _.get(item, 'attributes.transaction_type')
        ) > -1 &&
          Acl(permissions, ['E2E BPLS E-APPLICATION']) && (
            <div className="mx-2">
              <button
                className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
                type="button"
                onClick={handleViewApplication}
              >
                View Application
              </button>
            </div>
          )}
        {['EXPIRED SOA'].indexOf(
          _.get(item, 'included.bplsApplication.attributes.status')
        ) === -1 &&
          [
            'PENDING',
            'WAITING FOR PAYMENT',
            'EXPIRED REFERENCE NUMBER',
          ].indexOf(_.get(item, 'attributes.transaction_status')) > -1 &&
          ['RENEWAL'].indexOf(_.get(item, 'attributes.transaction_type')) >
            -1 &&
          // (_.get(item,"attributes.amount") > "500000") &&
          Acl(permissions, ['CHECK PAYMENT POSTING']) && (
            <button
              onClick={handlePaymentPosting}
              className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
              type="button"
            >
              Check Payment Posting
            </button>
          )}
        {+_.get(
          item,
          'included.bplsApplication.attributes.generated_soa_version'
        ) === 2 &&
          get(item, 'attributes.transaction_status') === 'PAID' && (
            <div className="mx-2">
              <button
                className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
                type="button"
                onClick={handleViewRetirementCertificate}
              >
                View Retirement Certificate
              </button>
            </div>
          )}
        {['PENDING', 'WAITING FOR PAYMENT', 'EXPIRED REFERENCE NUMBER'].indexOf(
          _.get(item, 'attributes.transaction_status')
        ) > -1 &&
          Acl(permissions, ['E2E BPLS E-SOA']) && (
            <div className="mx-2">
              <button
                className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
                type="button"
                onClick={handleViewSOA}
              >
                View SOA
              </button>
            </div>
          )}
        {['PAID', 'RECEIVED', 'RELEASED'].indexOf(
          _.get(item, 'included.bplsApplication.attributes.status')
        ) > -1 &&
          Acl(permissions, ['E2E BPLS E-OR']) && (
            <div className="mx-2">
              <button
                className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
                type="button"
                onClick={handleViewOR}
              >
                View OR
              </button>
            </div>
          )}
        {['PAID', 'RECEIVED', 'RELEASED'].indexOf(
          _.get(item, 'included.bplsApplication.attributes.status')
        ) > -1 &&
          _.get(item, 'included.bplsApplication.attributes.e_permit_no') &&
          Acl(permissions, ['E2E BPLS E-PERMIT']) && (
            <div className="mx-2">
              <button
                className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
                type="button"
                onClick={handleViewPermit}
              >
                View Permit
              </button>
            </div>
          )}
        {Acl(permissions, ['VIEW BPLS LOGS']) && (
          <div className="mx-2">
            <button
              className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
              type="button"
              onClick={handleViewLogs}
            >
              Logs
            </button>
          </div>
        )}
      </div>
      <div className="row justify-content-end mb-1 mr-1">
        {['COMPUTED', 'EXPIRED SOA', 'EXPIRED REFERENCE NUMBER'].indexOf(
          _.get(item, 'included.bplsApplication.attributes.status')
        ) > -1 &&
        _.get(item, 'attributes.refno') === null &&
        !isStartAssessment
          ? Acl(permissions, ['REGENERATE BPLS SOA']) && (
              <div className="mx-2">
                <button
                  disabled={isLoading}
                  onClick={handleRecalculateSOADate}
                  type="button"
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary  ml-1 font-weight-bold   "
                >
                  Recalculate SOA
                </button>
              </div>
            )
          : ''}
        {match.params.transaction_type === 'renewal' &&
          Acl(permissions, ['E2E BPLS RENEWAL APPROVE']) &&
          checkAssessor() &&
          get(item, 'included.bplsBusiness.attributes.bin') &&
          isValidated === 1 &&
          renewalApproveConfirmation.component}
        {match.params.transaction_type === 'renewal' &&
          Acl(permissions, ['E2E BPLS RENEWAL START LICENSE ASSESSMENT']) &&
          isPrintedApplication === 1 &&
          checkAssessor() &&
          renewalStartLicenseAssessment.component}
        {Acl(permissions, ['E2E BPLS FORWARD TO LICENSE']) &&
          checkAssessor() &&
          (get(item, 'included.bplsApplication.attributes.type') === 'NEW' ||
            // get(item, 'included.bplsApplication.attributes.type') ===
            //   'RENEWAL' ||
            // get(item, 'included.bplsApplication.attributes.type') ===
            //   'CHANGE' ||
            get(item, 'included.bplsApplication.attributes.type') ===
              'RETIREMENT') &&
          get(item, 'included.bplsBusiness.attributes.bin') &&
          isValidated === 1 &&
          forwardToLicenseConfirmation.component}
        {Acl(permissions, ['E2E BPLS RENEWAL FORWARD TO LICENSE']) &&
          checkAssessor() &&
          get(item, 'included.bplsApplication.attributes.type') === 'RENEWAL' &&
          get(item, 'included.bplsBusiness.attributes.bin') &&
          isValidated === 1 &&
          forwardToLicenseConfirmation.component}
        {Acl(permissions, ['E2E BPLS CHANGE FORWARD TO LICENSE']) &&
          checkAssessor() &&
          get(item, 'included.bplsApplication.attributes.type') === 'CHANGE' &&
          get(item, 'included.bplsBusiness.attributes.bin') &&
          isValidated === 1 &&
          forwardToLicenseConfirmation.component}
        {Acl(permissions, ['E2E GENERATE SOA']) &&
          checkAssessor() &&
          generateSOAConfirmation.component}
        {Acl(permissions, ['E2E BPLS GENERATE BIN']) &&
          checkAssessor() &&
          get(item, 'included.bplsApplication.attributes.type') === 'NEW' &&
          generateBINHooks.component}
        {get(item, 'included.bplsBusiness.attributes.taxpayer_id') !== null
          ? Acl(permissions, ['E2E BPLS INITIAL COMPUTATION']) &&
            get(item, 'included.bplsApplication.attributes.type') !==
              'CHANGE' &&
            get(item, 'included.bplsApplication.attributes.type') !==
              'RETIREMENT' &&
            checkAssessor() &&
            initialComputationHooks.component
          : ''}
        {/* Assess Application */}
        {['FOR CHECKING'].indexOf(
          _.get(item, 'attributes.transaction_status')
        ) > -1 &&
        _.get(item, 'attributes.start_assess_by') &&
        _.get(item, 'included.bplsApplication.attributes.status') ===
          'FOR PERMIT PROCESS' &&
        checkAssessor()
          ? Acl(permissions, ['E2E BPLS VALIDATE BUSINESS']) &&
            match.params.transaction_type === 'new' && (
              <div className="mx-2">
                <button
                  disabled={isLoading}
                  onClick={handleUpdateInformation}
                  type="button"
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold   "
                >
                  Assess Application
                </button>
              </div>
            )
          : ''}
        {['FOR CHECKING'].indexOf(
          _.get(item, 'attributes.transaction_status')
        ) > -1 &&
        _.get(item, 'attributes.start_assess_by') &&
        _.get(item, 'included.bplsApplication.attributes.status') ===
          'FOR PERMIT PROCESS' &&
        checkAssessor()
          ? Acl(permissions, ['E2E BPLS VALIDATE BUSINESS']) &&
            match.params.transaction_type === 'renewal' && (
              <div className="mx-2">
                <button
                  disabled={isLoading}
                  onClick={handleAssessRenewApplication}
                  type="button"
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold   "
                >
                  Assess Application
                </button>
              </div>
            )
          : ''}
        {['FOR CHECKING'].indexOf(
          _.get(item, 'attributes.transaction_status')
        ) > -1 &&
        _.get(item, 'attributes.start_assess_by') &&
        _.get(item, 'included.bplsApplication.attributes.status') ===
          'FOR PERMIT PROCESS' &&
        checkAssessor()
          ? Acl(permissions, ['E2E BPLS VALIDATE BUSINESS']) &&
            match.params.transaction_type === 'change' && (
              <div className="mx-2">
                <button
                  disabled={isLoading}
                  onClick={handleChangeRequestModal}
                  type="button"
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary  ml-1 font-weight-bold   "
                >
                  Assess Change Request
                </button>
              </div>
            )
          : ''}
        {['FOR CHECKING'].indexOf(
          _.get(item, 'attributes.transaction_status')
        ) > -1 &&
        _.get(item, 'attributes.start_assess_by') &&
        _.get(item, 'included.bplsApplication.attributes.status') ===
          'FOR PERMIT PROCESS' &&
        checkAssessor()
          ? Acl(permissions, ['E2E BPLS VALIDATE BUSINESS']) &&
            match.params.transaction_type === 'retirement' && (
              <div className="mx-2">
                <button
                  disabled={isLoading}
                  onClick={handleRetirementAssessModal}
                  type="button"
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary  ml-1 font-weight-bold   "
                >
                  Assess
                </button>
              </div>
            )
          : ''}
      </div>
      <div className="row justify-content-end mb-1 mr-1">
        {['PAID', 'RECEIVED', 'RELEASED'].indexOf(
          _.get(item, 'included.bplsApplication.attributes.status')
        ) > -1 &&
        (get(item, 'included.bplsApplication.attributes.type') === 'NEW' ||
          get(item, 'included.bplsApplication.attributes.type') ===
            'RENEWAL') &&
        _.get(item, 'included.bplsApplication.attributes.e_permit_no')
          ? Acl(permissions, ['E2E BPLS UPLOAD CTC']) && (
              <div className="mx-2">
                <button
                  disabled={isLoading}
                  onClick={handleUploadCTC}
                  type="button"
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary  ml-1 font-weight-bold"
                >
                  Upload CTC
                </button>
              </div>
            )
          : ''}
        {['PAID', 'RECEIVED'].indexOf(
          _.get(item, 'included.bplsApplication.attributes.status')
        ) > -1
          ? Acl(permissions, ['E2E BPLS UPDATE BUSINESS STATE']) && (
              <div className="mx-2">
                <button
                  disabled={isLoading}
                  onClick={handleUpdateBusinessState}
                  type="button"
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary  ml-1 font-weight-bold"
                >
                  Update Business State
                </button>
              </div>
            )
          : ''}
        {['PAID', 'RECEIVED'].indexOf(
          _.get(item, 'included.bplsApplication.attributes.status')
        ) > -1
          ? Acl(permissions, ['E2E BPLS UPDATE BILLING']) && (
              <div className="mx-2">
                <button
                  disabled={isLoading}
                  onClick={handleUpdateBilling}
                  type="button"
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary  ml-1 font-weight-bold"
                >
                  Update Billing
                </button>
              </div>
            )
          : ''}
        {['PAID'].indexOf(
          _.get(item, 'included.bplsApplication.attributes.status')
        ) > -1
          ? Acl(permissions, ['E2E BPLS UPDATE OR DATE']) && (
              <div className="mx-2 mb-2">
                <button
                  disabled={isLoading}
                  onClick={handleUpdateOrDate}
                  type="button"
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary  ml-1 font-weight-bold"
                >
                  Update OR Date
                </button>
              </div>
            )
          : ''}
        {['PENDING', 'WAITING FOR PAYMENT', 'EXPIRED REFERENCE NUMBER'].indexOf(
          _.get(item, 'attributes.transaction_status')
        ) > -1
          ? Acl(permissions, ['E2E BPLS MANUAL PAYMENT POSTING']) && (
              <div className="mx-2">
                <button
                  disabled={isLoading}
                  onClick={handleManualPaymentPosting}
                  type="button"
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary  ml-1 font-weight-bold"
                >
                  Manual Payment Posting
                </button>
              </div>
            )
          : ''}
        {match.params.transaction_type === 'quarterly' &&
          ((Acl(permissions, ['E2E BPLS QUARTERLY START REASSESSMENT']) &&
            isStartAssessment === 0) ||
            (Acl(permissions, ['E2E BPLS QUARTERLY STOP REASSESSMENT']) &&
              isStartAssessment === 1)) &&
          checkAssessor() &&
          quarterlyStartAssessment.component}
        {match.params.transaction_type === 'renewal' &&
          Acl(permissions, ['E2E BPLS RENEWAL START ASSESSMENT']) &&
          checkAssessor() &&
          isPrintedApplication === 1 &&
          renewalStartAssessment.component}
        {match.params.transaction_type === 'new' &&
          Acl(permissions, ['E2E BPLS START PERMIT ASSESSMENT']) &&
          checkAssessor() &&
          isPrintedApplication === 1 &&
          startAssessment.component}
        {match.params.transaction_type === 'renewal' &&
          Acl(permissions, ['E2E BPLS RENEWAL START PERMIT ASSESSMENT']) &&
          checkAssessor() &&
          isPrintedApplication === 1 &&
          startAssessment.component}
        {match.params.transaction_type === 'change' &&
          Acl(permissions, ['E2E BPLS CHANGE START PERMIT ASSESSMENT']) &&
          checkAssessor() &&
          isPrintedApplication === 1 &&
          startAssessment.component}
        {((match.params.transaction_type !== 'renewal' &&
          Acl(permissions, ['E2E BPLS START LICENSE ASSESSMENT'])) ||
          (match.params.transaction_type === 'renewal' &&
            Acl(permissions, ['E2E BPLS RENEWAL LICENSE ASSESSMENT']))) &&
          isPrintedApplication === 1 &&
          checkAssessor() &&
          startLicenseAssessment.component}
        {Acl(permissions, ['E2E BPLS APPROVE OWNERSHIP']) &&
          approveOwnershipComputation.component}
        {match.params.transaction_type !== 'change' &&
          Acl(permissions, ['E2E BPLS APPROVE']) &&
          approveConfirmation.component}
        {Acl(permissions, ['E2E BPLS REJECT']) &&
          checkAssessor() &&
          rejectConfirmation.component}
        {Acl(permissions, ['CANCEL BPLS APPLICATION']) &&
          cancelApplicationConfirmation.component}
        {Acl(permissions, ['E2E BPLS QUARTERLY COMPLETE REASSESSMENT']) &&
          reassessApplicationConfirmation.component}
        {Acl(permissions, ['E2E BPLS RELEASE']) &&
          releaseConfirmation.component}
        {Acl(permissions, ['BPLS CANCEL SOA']) &&
          cancelSoaConfirmation.component}
        {Acl(permissions, ['E2E BPLS RETURN TO PERMIT']) &&
          checkAssessor() &&
          ['NEW'].indexOf(_.get(item, 'attributes.transaction_type')) > -1 &&
          returnToPermitConfirmation.component}
        {Acl(permissions, ['E2E BPLS RENEWAL RETURN TO PERMIT']) &&
          checkAssessor() &&
          ['RENEWAL'].indexOf(_.get(item, 'attributes.transaction_type')) >
            -1 &&
          returnToPermitConfirmation.component}
        {Acl(permissions, ['E2E BPLS CHANGE RETURN TO PERMIT']) &&
          checkAssessor() &&
          ['CHANGE'].indexOf(_.get(item, 'attributes.transaction_type')) > -1 &&
          returnToPermitConfirmation.component}
        {match.params.transaction_type === 'renewal' &&
          Acl(permissions, ['E2E BPLS RETURN TO ASSESSMENT']) &&
          checkAssessor() &&
          ['RENEWAL'].indexOf(_.get(item, 'attributes.transaction_type')) >
            -1 &&
          renewalReturnToAssessmentConfirmation.component}
      </div>
      <div className="p-3">
        <Tabs>
          <SideScrollingTab dragToScroll>
            <TabList>
              <Tab>Transaction</Tab>
              <Tab>Account</Tab>
              <Tab>Business</Tab>
              <Tab>Activities</Tab>
              {get(item, 'attributes.transaction_type') !== 'QUARTERLY' && (
                <Tab>Requirements</Tab>
              )}
              {get(item, 'included.bplsPermitFees', []).length > 0 && (
                <Tab>Fees</Tab>
              )}
              <Tab>Location</Tab>
            </TabList>
          </SideScrollingTab>
          <TabPanel>
            <TransactionInformation data={item} />
          </TabPanel>
          <TabPanel>
            <TaxpayerInformation data={get(item, 'included.taxPayer')} />
          </TabPanel>
          <TabPanel>
            <BusinessInformation
              data={get(item, 'included.bplsBusiness')}
              remarks={item}
              handleAddRemarks={handleAddRemarks}
              handleAddApprovalNotes={handleAddApprovalNotes}
              isLoading={isLoading}
              isAssessor={checkAssessor()}
            />
          </TabPanel>
          <TabPanel>
            <BusinessActivities
              data={get(item, 'included.bplsBusinessActivities')}
              businessInformation={item}
              isStartAssessment={isStartAssessment}
              checkAssessor={checkAssessor}
              reassessmentActivities={activities}
              setActivities={setActivities}
            />
          </TabPanel>
          {get(item, 'attributes.transaction_type') !== 'QUARTERLY' && (
            <TabPanel>
              <Requirements
                data={get(item, 'included.bplsPermitRequirements')}
              />
            </TabPanel>
          )}
          {get(item, 'included.bplsPermitFees', []).length > 0 && (
            <TabPanel>
              <FinalFeesInformation
                data={get(item, 'included.bplsPermitFees')}
                granTotal={get(item, 'attributes.amount')}
                permitId={match.params.bpls_id}
                applicationInfo={get(item, 'included.bplsApplication')}
              />
            </TabPanel>
          )}
          <TabPanel>
            <Location
              pinLocation={
                get(
                  item,
                  'included.bplsBusiness.attributes.pinned_geolocation'
                ) || ''
              }
              data={get(item, 'included.bplsBusiness.attributes')}
            />
          </TabPanel>
        </Tabs>
      </div>
    </div>
  );
}

const mapStateToProps = ({ api }) => {
  return {
    adminProfile: getJson('profile'),
    item: get(api, `${c.ITEM}.item`) || {},
    permitApplication: get(api, `${c.ITEM}.res`) || {},
    isLoading: api.loading.indexOf(c.ITEM) > -1,
    assisting: api.loading.indexOf(c.TOGGLE_ASSESSMENT) > -1,
    initialComputing: api.loading.indexOf(c.INITIAL_COMPUTATION) > -1,
    approving: api.loading.indexOf(c.APPROVE) > -1,
    rejecting: api.loading.indexOf(c.REJECT) > -1,
    releasing: api.loading.indexOf(c.RELEASE) > -1,
    ownershipApproving: api.loading.indexOf(c.APPROVE_OWNERSHIP) > -1,
    permissions: getJson('permissions'),
    generatingSOA: api.loading.indexOf(c.GENERATE_SOA) > -1,
    forwardingToLicense: api.loading.indexOf(c.FORWARD_TO_LICENSE) > -1,
    generatingBIN: api.loading.indexOf(c.GENERATE_BIN) > -1,
    cancellingSoa: api.loading.indexOf(c.CANCEL_SOA) > -1,
    cancellingApplication: api.loading.indexOf(c.CANCEL_APPLICATION) > -1,
    returningToPermit: api.loading.indexOf(c.RETURN_TO_PERMIT) > -1,
    recalculatingSOA: api.loading.indexOf(c.RECALCULATE_SOA) > -1,
    reassessingApplication: api.loading.indexOf(c.CANCEL_APPLICATION) > -1,
  };
};

const enhance = flowRight([withRouter, connect(mapStateToProps, actions)]);

Content.propTypes = {
  adminProfile: PropTypes.instanceOf(Object).isRequired,
  item: PropTypes.instanceOf(Object).isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  permitApplication: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  toggleAssessment: PropTypes.instanceOf(Function).isRequired,
  toggleLicenseAssessment: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  assisting: PropTypes.bool.isRequired,
  generatingBIN: PropTypes.bool.isRequired,
  initialComputing: PropTypes.bool.isRequired,
  approving: PropTypes.bool.isRequired,
  rejecting: PropTypes.bool.isRequired,
  releasing: PropTypes.bool.isRequired,
  ownershipApproving: PropTypes.bool.isRequired,
  generateBIN: PropTypes.instanceOf(Function).isRequired,
  initialComputation: PropTypes.instanceOf(Function).isRequired,
  approve: PropTypes.instanceOf(Function).isRequired,
  // reject: PropTypes.instanceOf(Function).isRequired,
  release: PropTypes.instanceOf(Function).isRequired,
  approveOwnership: PropTypes.instanceOf(Function).isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
  list: PropTypes.instanceOf(Array).isRequired,
  refreshList: PropTypes.instanceOf(Function).isRequired,
  generatingSOA: PropTypes.bool.isRequired,
  generateSOA: PropTypes.instanceOf(Function).isRequired,
  forwardingToLicense: PropTypes.bool.isRequired,
  forwardToLicense: PropTypes.instanceOf(Function).isRequired,
  cancellingSoa: PropTypes.bool.isRequired,
  cancelSoa: PropTypes.instanceOf(Function).isRequired,
  cancellingApplication: PropTypes.bool,
  cancelApplication: PropTypes.instanceOf(Function).isRequired,
  returningToPermit: PropTypes.bool.isRequired,
  returnToPermit: PropTypes.instanceOf(Function).isRequired,
  recalculatingSOA: PropTypes.bool.isRequired,
  recalculateSOA: PropTypes.instanceOf(Function).isRequired,
  inquirePreviousOR: PropTypes.instanceOf(Function).isRequired,
  reassessApplication: PropTypes.instanceOf(Function).isRequired,
  reassessingApplication: PropTypes.bool,
};

export default enhance(Content);
